import { TextField } from '@mui/material';
import styled from 'styled-components';
import { LoadingButton } from '@mui/lab';

interface ILoginStyle {
  isDark: boolean;
}

const LoginStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px ${(props: ILoginStyle) => (props.isDark ? '#121212' : '#fff')} inset !important;
    box-shadow: 0 0 0px 1000px ${(props: ILoginStyle) => (props.isDark ? '#121212' : '#fff')} inset !important;
  }
`;
const LoginImage = styled.div`
  width: 100%;
  height: 100%;
  margin: 0px;
  overflow: hidden;
  background-image: url(${require('../../assets/img_login.jpeg')});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  @media screen and (max-width: 600px) {
    visibility: hidden;
    width: 0px;
  }
`;
const LoginFormContainer = styled.div`
  width: 700px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const MainTitle = styled.div`
  font-size: 35px;
  color: rgb(32, 144, 136);
`;
const SecondaryTitle = styled.div`
  font-size: 23px;
  color: dimgrey;
  font-weight: 300;
  letter-spacing: 6px;
`;
const AccessMessage = styled.div`
  font-size: 15px;
  color: dimgrey;
  font-weight: 100;
  margin-top: 30px;
`;
const Form = styled.form`
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const LoginButton = styled(LoadingButton)`
  width: 100%;
`;
const EmailTextFiled = styled(TextField)`
  width: 100%;
  margin: 5px 0px 10px 0px !important;
  box-sizing: content-box;
`;
const PasswordTextFiled = styled(TextField)`
  width: 100%;
  margin: 10px 0px 25px 0px !important;
  box-sizing: content-box;
`;

const Link = styled.button`
  text-decoration: none;
  background: transparent;
  color: #1e293b;
  border: none;
  font-weight: 600;
  font-size: 14px;
  transition: color 0.2s;
  outline-style: none;
  &:hover {
    color: #2563eb;
    cursor: pointer;
  }
`;

const ContainerFileAndConsult = styled.div`
  display: flex;
  margin-top: 80px;
  gap: 8px;
`;

const FileAndConsult = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 16px;
  background: #f8fafc;
  transition: all 0.2s ease;
  cursor: pointer;
  margin: 8px;
  gap: 8px;

  &:hover {
    background: #eff6ff;
    border-color: #bfdbfe;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.1);

    svg {
      color: #2563eb;
    }
  }

  svg {
    color: #64748b;
    font-size: 20px;
    transition: color 0.2s;
  }
`;

const DividerText = styled.span`
  display: block;
  margin-top: 16px;
  font-size: 12px;
  color: #94a3b8;
  text-align: center;
  font-weight: 500;
`;

export {
  LoginStyled,
  LoginImage,
  LoginFormContainer,
  MainTitle,
  SecondaryTitle,
  AccessMessage,
  Form,
  LoginButton,
  EmailTextFiled,
  PasswordTextFiled,
  Link,
  ContainerFileAndConsult,
  FileAndConsult,
  DividerText
};
